import { render, staticRenderFns } from "./SalemanConfigAndSetting.vue?vue&type=template&id=b81a706e&scoped=true&"
import script from "./SalemanConfigAndSetting.vue?vue&type=script&lang=js&"
export * from "./SalemanConfigAndSetting.vue?vue&type=script&lang=js&"
import style0 from "./SalemanConfigAndSetting.vue?vue&type=style&index=0&id=b81a706e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81a706e",
  null
  
)

export default component.exports